import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StyledButton from 'common/StyledButton';
import css from './MoreInformation.css';
import TextHeader from "./TextHeader";
import { TextArea } from "semantic-ui-react";
import { urlParams } from 'utils/request';
import useError from "../hooks/useError";
import SubmitStudentAPI from "./SubmitStudentAPI";

function MoreInformation(props) {

  const [{success, error}, {onSubmitStudentApi, onSubmitProspectApi}] = SubmitStudentAPI(props.setWaitingRoomQueueId);
  const [description, setDescription] = useState("");

  if (success) {
    props.goToConfirmationPage();
  }

  const onSubmitStudent = (ignoreDescription) => {
    const params = urlParams({
      studentId: props.studentId,
      serviceId: props.serviceId,
      reasonId: props.reasonId,
      kioskId: props.kioskId,
      courseId: props.courseId,
      groupSessionId: props.groupSessionId,
      description: ignoreDescription ? '' : description
    }, false);
    onSubmitStudentApi(params);
  };

  const onSubmitProspect = (ignoreDescription) => {
    const params = JSON.stringify({
      studentId: props.studentId,
      serviceId: props.serviceId,
      reasonId: props.reasonId,
      kioskId: props.kioskId,
      courseId: props.courseId,
      groupSessionId: props.groupSessionId,
      description: ignoreDescription ? '' : description,
      secondaryEmail: props.email,
      prospectWalkin: props.isProspectiveStudent
    });
    onSubmitProspectApi(params);
  };

  useError(error, props.setError);

  return (
    <div>
      <div className={css['content']}>
        <TextHeader
          upperText={props.greetingText}
          lowerText={props.mainHeadingText}
        />

          <TextArea
            className={css['text-box']}
            rows={5}
            autoHeight
            aria-label={`Enter more information`}
            onChange={e => setDescription(e.target.value)}
          />
        <StyledButton
          type="submit"
          className={css['primary-button']}
          onClick={() => { props.isProspectiveStudent ? onSubmitProspect(false) : onSubmitStudent(false)}}>
          Submit
        </StyledButton>

        <StyledButton
          asLink
          type="submit"
          className={css['link-button']}
          onClick={() => { props.isProspectiveStudent ? onSubmitProspect(true) : onSubmitStudent(true)} }>
          Skip this step.
        </StyledButton>
      </div>
    </div>
  );
}

MoreInformation.propTypes = {
  greetingText: PropTypes.string.isRequired,
  mainHeadingText: PropTypes.string.isRequired,
  kioskId: PropTypes.number.isRequired,
  setError: PropTypes.func.isRequired,
  serviceId: PropTypes.number.isRequired,
  studentId: PropTypes.number,
  reasonId: PropTypes.number,
  courseId: PropTypes.number,
  groupSessionId: PropTypes.number,
  isProspectiveStudent: PropTypes.bool.isRequired,
  startOver: PropTypes.func.isRequired,
  goToConfirmationPage: PropTypes.func.isRequired,
  setWaitingRoomQueueId: PropTypes.func.isRequired,
  email: PropTypes.string
};

export default MoreInformation;
